// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as AllocationCampaignList from "./table-component/AllocationCampaignList.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as AllocationDashboardHomeFilter from "./AllocationDashboardHomeFilter.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";
import * as AllocationDashboardStateMachine from "../AllocationDashboardStateMachine.bs.js";

function getCreateCampaignButton(dispatch) {
  return React.createElement(RoundedPrimaryButton$Catalyst.make, {
              buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                    TAG: /* Custom */1,
                    _0: (function (param) {
                        return React.createElement("p", {
                                    className: "create-campaign-btn-text"
                                  }, "Create New Campaign");
                      })
                  }, undefined, (function (param) {
                      return Curry._1(dispatch, {
                                  TAG: /* UpdateSidebarState */6,
                                  opened_sidebar: /* CreateCampaignContainer */0
                                });
                    }), undefined, undefined, undefined, undefined, "create-campaign-btn", undefined, undefined)
            });
}

function getManagePriorityButton(dispatch) {
  return React.createElement(PrimaryButton$Catalyst.make, {
              buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                    TAG: /* Custom */1,
                    _0: (function (param) {
                        return React.createElement("p", {
                                    className: "manage-priority-btn-text"
                                  }, "Manage Priorities");
                      })
                  }, undefined, (function (param) {
                      return Curry._1(dispatch, {
                                  TAG: /* UpdateSidebarState */6,
                                  opened_sidebar: /* ManagePriorities */3
                                });
                    }), undefined, undefined, undefined, undefined, "manage-priority-btn", undefined, undefined)
            });
}

function AllocationDashboardHome(Props) {
  var state = Props.state;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  React.useEffect(function () {
        AllocationDashboardStateMachine.storeSelectedGeoRegionIdInLocalStorage(state.selected_geo_region);
        AllocationDashboardStateMachine.storeSelectedVehicleIdInLocalStorage(state.selected_vehicle);
        
      });
  React.useEffect((function () {
          var geo_region = state.selected_geo_region;
          if (geo_region === undefined) {
            return ;
          }
          AllocationDashboardStateMachine.fetchZones(geo_region, dispatch, country);
          AllocationDashboardStateMachine.fetchClusters(geo_region, dispatch, country);
          var vehicle = state.selected_vehicle;
          if (vehicle !== undefined) {
            AllocationDashboardStateMachine.fetchZonalClusterCampaign(vehicle, geo_region, dispatch, country);
            return ;
          }
          
        }), [
        state.selected_geo_region,
        state.selected_vehicle
      ]);
  var match$1 = state.user_role;
  var match$2 = state.filtered_allocation_campaings;
  var tmp;
  if (typeof match$1 === "number" || !(match$1.TAG === /* Live */1 && !(typeof match$2 === "number" || match$2.TAG !== /* Live */1))) {
    tmp = null;
  } else {
    var match$3 = match$1._0.access_level;
    tmp = match$3 >= 2 ? getManagePriorityButton(dispatch) : React.createElement(React.Fragment, undefined, getCreateCampaignButton(dispatch), getManagePriorityButton(dispatch));
  }
  return React.createElement("div", {
              className: "ald-homepage-container"
            }, React.createElement(AllocationDashboardHomeFilter.make, {
                  state: state,
                  dispatch: dispatch
                }), React.createElement(AllocationCampaignList.make, {
                  state: state,
                  dispatch: dispatch
                }), React.createElement("div", {
                  className: "create-and-manage-priority-btn-container"
                }, tmp));
}

var make = AllocationDashboardHome;

export {
  getCreateCampaignButton ,
  getManagePriorityButton ,
  make ,
  
}
/* react Not a pure module */
